import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
} from 'api';
import { SupplierResponse } from 'features/master/api/master-api.service';
export const DashboardApiService = () => {
  const getdashboard = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `AdminWeighbridge/Dashboard`,
      params,
    });

    return response.data;
  };

  return {
    getdashboard
  };
};



